import { ReduxStore } from 'store/types';

function getDetailsIsLoading(state: ReduxStore): boolean {
  return state.intervention.getDetails.config.isLoading;
}

export default getDetailsIsLoading;
